<template>
  <div class="p-4">
    <div class="bg-white rounded-lg p-4 inline-block">
      <span class="font-bold text-xl block">{{ $t('Account löschen') }}</span>
      <span v-html="$t('Wenn Sie ihren Account löschen, entfernen wir Ihre Daten gemäß unserer <a href=&quot;{privacyUrl}&quot; class=&quot;text-primary&quot;>Datenschutzerklärung</a>. Diese Aktion kann nicht rückgängig gemacht werden.', { privacyUrl: 'https://www.ev-angel-isch.de/datenschutz/' })"></span>
      
      <div class="mt-4">
      <span class="font-bold text-red-500 inline-block" v-if="confirmDeletion">{{ $t('Sind Sie sich sicher? Zur Bestätigung, betätigen Sie den Button erneut.') }}</span><br>
      <button class="full-red" @click="deleteAccount()">{{ $t('Account löschen') }}</button>
  </div>
</div>
</div>
</template>
<style scoped>
.dotr,
.dotl {
  width: 10px;
  height: 10px;
  background-color: green;
  position: absolute;
  top: 50%;
  animation: moveRight 2s infinite alternate;
}
.dotl {
  animation: moveLeft 2s infinite alternate;
}

@keyframes moveRight {
  from {
    left: 0;
  }

  to {
    left: 100%;
  }
}
@keyframes moveLeft {
  to {
    left: 0;
  }

  from {
    left: 100%;
  }
}
</style>
<script>
// @ is an alias to /src
import QR from "@/lib/QR.js";
import API from "@/API";
export default {
  name: "Cards",
  components: {
    QR,
  },
  data() {
    return {
      confirmDeletion: false
    };
  },
  props: {
    cards: Array,
  },
  methods: {
    deleteAccount(){
      if(this.confirmDeletion){
        API.deleteAccount((r, status) => {
          if (status === 200) {
            this.$emit("toast", this.$t('Ihr Account wurde gelöscht.'), "success");
            setTimeout(()=>{
              window.location="/"
            },2000)
          }
        })
      }
      else{
        this.confirmDeletion = true
      }
    }
  },
};
</script>
  